import React from "react";
import Button from "../shared/button";
import { Title, TextDescription } from "../shared/text/Text";
import styles from './Modal.module.css';
import { modal } from "../modalManagment";

const ModalCreateGuaranteePayment = ({ onClick }) => {
    return (
        <div className={styles.containerModal} style={{ marginTop: '100px' }}>
            <Title styles={styles.textModalTitle}>RETENER GARANTÍA</Title>
            <TextDescription styles={styles.textDescription}>Se realizará la retención del cobro de garantía</TextDescription>
            <TextDescription styles={styles.textDescription}>¿Deseas continuar?</TextDescription>
            <div className={styles.containButtons}>
                <Button label="Cancelar" outline styles={styles.buttonMiddle} onClick={() => modal.close()} />
                <Button label="Retener garantía" styles={`${styles.buttonMiddle} ${styles.buttonPrimary}`} onClick={onClick} />
            </div>
        </div>
    )
}

export default ModalCreateGuaranteePayment;